import request from '../axios'
import requestSec from '../axiosSec'

// 集团账号
// 获取成员列表
export const sysuserList = params => request({
	url: 'sys/sysuser/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 注销成员
export const sysuserCancelAccount = data => request({
	url: 'sys/sysuser/cancelAccount',
	method: 'post',
	data: data,
})

// 移除成员
export const sysuserRemoveAccount = data => request({
	url: 'sys/sysuser/removeAccount',
	method: 'post',
	data: data,
})

// 获取预计工号
export const sysuserGuessJobNumber = params => request({
	url: 'sys/sysuser/guessJobNumber',
	method: 'get',
	params: params
})

// 获取认证状态
export const coreauthListAll = params => request({
	url: 'config/coreauth/listAll',
	method: 'get',
	params: params
})

// 集团配置--新增认证情况
export const coreauthSave = data => request({
	url: 'config/coreauth/save',
	method: 'post',
	data: data,
})

// 集团配置--修改认证情况
export const coreauthUpdate = data => request({
	url: 'config/coreauth/update',
	method: 'post',
	data: data,
})

// 集团配置--修改认证名称
export const coreauthUpdateName = data => request({
	url: 'config/coreauth/updateName',
	method: 'post',
	data: data,
})

// 集团配置--删除认证情况
export const coreauthDelete = data => request({
	url: 'config/coreauth/delete',
	method: 'post',
	data: data,
})

// 获取功能权限列表(添加成员--带自定义)
export const sysmenupowerAddUserList = params => request({
	url: 'sys/sysmenupower/addUserList',
	method: 'get',
	params: params
})

// 获取功能权限列表（不带自定义）
export const configmenupowerListAll = params => request({
	url: 'config/configmenupower/listAll',
	method: 'get',
	params: params
})

// 集团配置--新增功能权限
export const configmenupowerSave = data => request({
	url: 'config/configmenupower/save',
	method: 'post',
	data: data,
})

// 集团配置--修改功能权限名字
export const configmenupowerUpdateName = data => request({
	url: 'config/configmenupower/updateName',
	method: 'post',
	data: data,
})

// 集团配置--删除功能权限
export const configmenupowerDelete = data => request({
	url: 'config/configmenupower/delete',
	method: 'post',
	data: data,
})

// 修改功能权限(菜单)
export const configmenupowerUpdate = data => request({
	url: 'config/configmenupower/update',
	method: 'post',
	data: data,
})

// 获取默认功能权限菜单
export const configmenupowerDefaultMenu = params => request({
	url: 'config/configmenupower/defaultMenu',
	method: 'get',
	params: params
})

// 查询名字、账号是否重复(返回true表示可以使用，false表示有重复)
export const sysuserCheckUserNameOrAccount = data => request({
	url: 'sys/sysuser/checkUserNameOrAccount',
	method: 'post',
	data: data,
})

// 获取部门数据
export const sysdepartmentListAllDepartment = params => request({
	url: 'sys/sysdepartment/listAllDepartment',
	method: 'get',
	params: params
})

// 添加成员
export const sysuserAddNewUser = data => request({
	url: 'sys/sysuser/addNewUser',
	method: 'post',
	data: data,
})

// 获取成员信息
export const sysuserInfoById = params => request({
	url: 'sys/sysuser/infoById/' + params.id,
	method: 'get',
})

// 获取成员信息--底部展示
export const sysuserBottomShowById = params => request({
	url: 'sys/sysuser/bottomShowById/' + params.id,
	method: 'get',
})

// 编辑成员
export const sysuserUpdateMember = data => request({
	url: 'sys/sysuser/updateMember',
	method: 'post',
	data: data,
})

// 获取公司/部门基本信息
export const sysdepartmentInfo = params => request({
	url: 'sys/sysdepartment/info',
	method: 'get',
	params: params
})

// 获取列表数据(获取部门成员)
export const sysuserDepartmentList = params => request({
	url: 'sys/sysuser/departmentList',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260312修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 新增部门
export const sysdepartmentSave = data => request({
	url: 'sys/sysdepartment/save',
	method: 'post',
	data: data,
})

// 编辑部门
export const sysdepartmentUpdate = data => request({
	url: 'sys/sysdepartment/update',
	method: 'post',
	data: data,
})

// 删除部门
export const sysdepartmentDelete = data => request({
	url: 'sys/sysdepartment/delete',
	method: 'post',
	data: data,
})

// 获取部门、成员数量
export const sysdepartmentListAllDepartmentNum = params => request({
	url: 'sys/sysdepartment/listAllDepartment',
	method: 'get',
	params: params
})

// 移入隐藏
export const sysuserTransferMemberHide = data => request({
	url: 'sys/sysuser/transferMemberHide',
	method: 'post',
	data: data,
})

// 移出隐藏
export const sysuserTransferMemberShow = data => request({
	url: 'sys/sysuser/transferMemberShow',
	method: 'post',
	data: data,
})

// 获取移入成员信息
export const sysuserUsersInfo = data => request({
	url: 'sys/sysuser/usersInfo',
	method: 'post',
	data: data,
})

// 确认移入成员（传入的成员ID会全部嵌入到新的部门）
export const sysuserTransferMember = data => request({
	url: 'sys/sysuser/transferMember',
	method: 'post',
	data: data,
})

// 变更日志
export const syschangelogList = params => request({
	url: 'sys/syschangelog/list',
	method: 'get',
	params: params
})

// 获取变更类型
export const syschangelogChangeTypes = params => request({
	url: 'sys/syschangelog/changeTypes',
	method: 'get',
	params: params
})

// 获取变更详情
export const syschangelogDetailed = data => request({
	url: 'sys/syschangelog/detailed',
	method: 'post',
	data: data,
})

// 获取集团配置信息
export const configcompanydeployInfo = params => request({
	url: 'config/configcompanydeploy/info',
	method: 'get',
	params: params
})

// 开启、关闭移除成员权限
export const configcompanydeployMemberRemovePermit = data => request({
	url: 'config/configcompanydeploy/memberRemovePermit',
	method: 'post',
	data: data,
})

// 开启、关闭注销成员权限
export const configcompanydeployMemberCancelPermit = data => request({
	url: 'config/configcompanydeploy/memberCancelPermit',
	method: 'post',
	data: data,
})

// 开启、关闭删除部门权限
export const configcompanydeployDepartmentDeletePermit = data => request({
	url: 'config/configcompanydeploy/departmentDeletePermit',
	method: 'post',
	data: data,
})

// 设置默认功能权限、认证情况、权限组、初始密码
export const configcompanydeployPowerOrPass = data => request({
	url: 'config/configcompanydeploy/powerOrPass',
	method: 'post',
	data: data,
})

// 获取部门、成员数量
export const sysdepartmentAllNumDepAndMember = data => request({
	url: 'sys/sysdepartment/allNumDepAndMember',
	method: 'post',
	data: data,
})

// 新增部门-负责人筛选
export const sysuserChargeUserList = params => request({
	url: 'sys/sysuser/chargeUserList',
	method: 'get',
	params: params
})

// 获取企业组织信息接口
export const syscompanyorganizationList = params => request({
	url: 'sys/syscompanyorganization/list',
	method: 'get',
	params: params
})

// 查询当前组织
export const syscompanyorganizationInfo = params => request({
	url: 'sys/syscompanyorganization/info/' + params.id,
	method: 'get',
})

// 新增组织
export const syscompanyorganizationSave = data => request({
	url: 'sys/syscompanyorganization/save',
	method: 'post',
	data: data,
})

// 编辑组织
export const syscompanyorganizationUpdate = data => request({
	url: 'sys/syscompanyorganization/update',
	method: 'post',
	data: data,
})

// 移除组织
export const syscompanyorganizationDelete = data => request({
	url: 'sys/syscompanyorganization/delete',
	method: 'post',
	data: data,
})

// 注销、移除成员前置接口
export const sysuserCancelRemovePrecheck = data => request({
	url: 'sys/sysuser/cancelRemovePrecheck',
	method: 'post',
	data: data,
})
